import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  AppBar,
  Badge,
  Box,
  Hidden,
  IconButton,
  Toolbar
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import InputIcon from '@material-ui/icons/Input';
// import Logo from './Logo';


//Redux
import { useSelector, useDispatch } from "react-redux";
import { getUserDetails, logout } from '../../redux/actions/auth';
import { SET_BACKBTN } from 'src/redux/actions/types';

const DashboardNavbar = ({ onMobileNavOpen, ...rest }) => {
  const [notifications] = useState([]);
  const dispatch = useDispatch();
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const { backBtn } = useSelector((state) => state.data);




  useEffect(() => {
    if(isLoggedIn){
      dispatch(getUserDetails())
    }
    localStorage.removeItem('copyQuestion');
  }, [])


    return (
    <AppBar
      elevation={0}
      {...rest}
    >
      <Toolbar>
       {backBtn &&  <RouterLink to={backBtn}
       onClick={() => dispatch({type: SET_BACKBTN, payload: null})}
       >
          {/* <img
            src="/static/Tlogo1.png"
            height="35px"
          /> */}
          <ArrowBackIcon className="text-light"/>
        </RouterLink>}
        <Box sx={{ flexGrow: 1 }} />
        <Hidden lgDown>
          <IconButton color="inherit">
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot"
            >
              <NotificationsIcon />
            </Badge>
          </IconButton>
          {/* <IconButton color="inherit" onClick={logOut}>
            <InputIcon />
          </IconButton> */}
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onMobileNavOpen}
          >
            <MenuIcon />
          </IconButton>

        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

DashboardNavbar.propTypes = {
  onMobileNavOpen: PropTypes.func
};

export default DashboardNavbar;
